angular.module('FlexyBeautyApp.services')
    .factory('WebsiteSubdomain',function () {

        let websiteSubdomain = {
            ABOUT               : "about",
            ACCOUNT             : "account",
            ADMIN               : "admin",
            BOOKING             : "booking",
            CART                : "cart",
            CATEGORY            : "category",
            CHECKOUT            : "checkout",
            CONTACT             : "contact",
            CUSTOMER_POST       : "customerPost",
            CGV                 : "cgv",
            CURE                : "cure",
            CURE_CATEG          : "cureCategory",
            FORGOT_PWD          : "forgotPwd",
            GIFT_ITEM           : "giftItem",
            GIFT_ITEMS          : "giftItems",
            GIFT_ITEMS_MAIL     : "giftItemsMail",
            HOME                : "home",
            IMAGES              : "images",
            LEGAL               : "legal",
            LOGIN               : "login",
            LOYALTY_CARD        : "loyaltyCard",
            LOYALTY_CARD_CATEG  : "loyaltyCardCategory",
            MOBILE_CART         : "mobileCart",
            NATIVE_APP          : "nativeApp",
            PRODUCT             : "product",
            PRODUCT_CATEG       : "productCategory",
            REGISTER            : "register",
            SEARCHED_SERVICES   : "searchedServices",
            SERVICE             : "service",
            VALIDATE_ACCOUNT    : "validateAccount"
        };

        return websiteSubdomain;
    });



// WEBPACK FOOTER //
// ./js/services/customerSite/ConstantsWebsiteSubdomain.js